<template>
  <div
    class="group w-[264px] h-[175px] rounded-lg overflow-hidden cursor-pointer relative bg-light-gray-bg"
    :class="props.isSelect ? 'border-mainColor-deep border-[2px] p-2' : ''"
    ref="imgItemRef"
  >
    <img
      :key="key"
      class="h-full w-full rounded object-contain"
      v-if="imgInfo.enhanceUrl"
      :src="imgInfo.enhanceUrl"
      alt="load fail"
      @load="load"
      @error="error"
    />
    <img
      class="h-full w-full rounded object-contain"
      v-else
      :src="imgInfo.localUrl"
      alt="enhance img"
    />
    <!-- <div
      v-if="imgInfo.enhanceUrl"
      class="h-full w-full rounded bg-cover bg-no-repeat bg-center"
      :style="`background-image: url(${imgInfo.enhanceUrl})`"
    ></div>
    <div
      v-else
      class="h-full w-full rounded bg-cover bg-no-repeat bg-center"
      :style="`background-image: url(${imgInfo.localUrl})`"
    ></div> -->
    <div
      class="h-full absolute top-0 left-0 w-full bg-[#1F1F1F80] flex items-center justify-center"
      v-if="
        props.imgInfo.status == uploadStatus.uploading ||
        props.imgInfo.status == uploadStatus.handle
      "
    >
      <Loading />
    </div>
    <div
      class="h-full absolute top-0 left-0 w-full bg-[#1F1F1F80] flex items-center justify-center flex-col text-white"
      v-if="
        props.imgInfo.status == uploadStatus.fail ||
        props.imgInfo.status == uploadStatus.uploadFail ||
        props.imgInfo.status == uploadStatus.imageLoadFail
      "
    >
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="mb-3"
      >
        <path
          d="M16 0C24.8368 0 32 7.1632 32 16C32 24.8368 24.8368 32 16 32C7.1632 32 0 24.8368 0 16C0 7.1632 7.1632 0 16 0ZM16 2.232C12.3485 2.232 8.84655 3.68255 6.26455 6.26455C3.68255 8.84655 2.232 12.3485 2.232 16C2.232 19.6515 3.68255 23.1534 6.26455 25.7354C8.84655 28.3174 12.3485 29.768 16 29.768C19.6515 29.768 23.1534 28.3174 25.7354 25.7354C28.3174 23.1534 29.768 19.6515 29.768 16C29.768 12.3485 28.3174 8.84655 25.7354 6.26455C23.1534 3.68255 19.6515 2.232 16 2.232ZM16 18.24C17.4152 18.2402 18.7818 18.7561 19.844 19.6912C20.9063 20.6262 21.5914 21.9163 21.7712 23.32C21.7956 23.465 21.7905 23.6133 21.7561 23.7563C21.7217 23.8992 21.6588 24.0337 21.5712 24.1517C21.4836 24.2697 21.373 24.3688 21.2461 24.443C21.1192 24.5172 20.9787 24.5651 20.8328 24.5836C20.687 24.6022 20.539 24.5911 20.3976 24.551C20.2561 24.5109 20.1243 24.4426 20.0099 24.3503C19.8955 24.258 19.8009 24.1435 19.7319 24.0138C19.6628 23.884 19.6207 23.7416 19.608 23.5952C19.4953 22.7158 19.0653 21.9079 18.3988 21.3233C17.7323 20.7387 16.8752 20.4177 15.9886 20.4207C15.102 20.4236 14.2471 20.7503 13.5845 21.3393C12.9219 21.9283 12.4972 22.7391 12.3904 23.6192C12.3757 23.7634 12.3324 23.9032 12.263 24.0305C12.1937 24.1578 12.0996 24.27 11.9864 24.3606C11.8732 24.4511 11.7431 24.5182 11.6037 24.5579C11.4643 24.5976 11.3183 24.6091 11.1744 24.5918C11.0305 24.5745 10.8915 24.5287 10.7654 24.457C10.6394 24.3853 10.529 24.2893 10.4405 24.1745C10.352 24.0596 10.2873 23.9283 10.2501 23.7882C10.2129 23.6481 10.2041 23.502 10.224 23.3584C10.3949 21.9466 11.0768 20.6463 12.141 19.703C13.2051 18.7596 14.5779 18.2403 16 18.24ZM9.3024 10.048C9.89436 10.048 10.4621 10.2832 10.8807 10.7017C11.2992 11.1203 11.5344 11.688 11.5344 12.28C11.5344 12.872 11.2992 13.4397 10.8807 13.8583C10.4621 14.2768 9.89436 14.512 9.3024 14.512C8.71044 14.512 8.14272 14.2768 7.72414 13.8583C7.30556 13.4397 7.0704 12.872 7.0704 12.28C7.0704 11.688 7.30556 11.1203 7.72414 10.7017C8.14272 10.2832 8.71044 10.048 9.3024 10.048ZM22.6976 10.048C23.2896 10.048 23.8573 10.2832 24.2759 10.7017C24.6944 11.1203 24.9296 11.688 24.9296 12.28C24.9296 12.872 24.6944 13.4397 24.2759 13.8583C23.8573 14.2768 23.2896 14.512 22.6976 14.512C22.1056 14.512 21.5379 14.2768 21.1193 13.8583C20.7008 13.4397 20.4656 12.872 20.4656 12.28C20.4656 11.688 20.7008 11.1203 21.1193 10.7017C21.5379 10.2832 22.1056 10.048 22.6976 10.048Z"
          fill="white"
        />
      </svg>

      <span v-if="props.imgInfo.status == uploadStatus.fail">{{
        $t("enhance-process-fail")
      }}</span>
      <span v-if="props.imgInfo.status == uploadStatus.imageLoadFail">{{
        $t("enhance-parse-fail")
      }}</span>
      <span v-if="props.imgInfo.status == uploadStatus.uploadFail">{{
        $t("enhance-upload-fail")
      }}</span>
    </div>
    <div v-if="loadingFail" class="h-full absolute top-0 left-0 w-full bg-[#1F1F1F80] flex items-center justify-center">
      <a @click="reloadImg" class="cursor-pointer underline ml-1 text-white">
          {{ $t("reload") }}</a
        >
    </div>
    <div class="absolute right-2 top-2 items-center gap-3 flex">
      <div
        class="h-8 w-8 bg-[#1F1F1FB2] hidden items-center justify-center group-hover:flex cursor-pointer rounded-lg"
        @click.stop="downloadImg"
        v-if="props.imgInfo.status >= uploadStatus.lodingImg"
      >
        <img
          src="/assets/images/enhance/download.svg"
          alt="download"
          width="20"
          height="20"
        />
      </div>
      <div
        v-if="props.isFinish"
        class="h-8 w-8 bg-[#1F1F1FB2] hidden items-center justify-center group-hover:flex cursor-pointer rounded-lg"
        @click.stop="delImg"
      >
        <img
          src="/assets/images/enhance/del.svg"
          alt="delete"
          width="20"
          height="20"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
// import { useUploadStore } from "@/store/upload";
// import messageBox from "@/composables/messageBox";
import { uploadStatus } from "@/utils/type";
// import { useMainStore } from "@/store/index";
// const { locale, t } = useI18n();
// const dayjs = useDayjs();
// const { isLogin, isVip, isVipPro, isNormalVip } = useUserInfo();
// const uploadStore = useUploadStore();
// const mainStore = useMainStore();
// const isAllDownloading = ref(false);
const props = defineProps({
  imgInfo: {
    type: Object,
    default: {},
  },
  isSelect: {
    type: Boolean,
    default: false,
  },
  isFinish: {
    type: Boolean,
    default: true,
  },
});
// const visible = ref(false);
// const imgItemRef = ref(null);
const key = ref(0)
const loadingFail = ref(false)
const emit = defineEmits(["delImg", "downloadImg", "load","error"]);
function delImg() {
  emit("delImg");
}
function downloadImg() {
  emit("downloadImg");
}
function load() {
  loadingFail.value = false
  emit("load");
}
function error(err) {
  setTimeout(() => {
    key.value += 1
    }, 1000);
  console.log('重试',key.value);
  if(key.value>3){
    loadingFail.value = true
    emit("error");
  }
}
function reloadImg() {
  key.value = 0;
  loadingFail.value = false
}
</script>
<style lang="scss"></style>
